/**
 * Specifies the conditions that govern the adjustment to the number of units of the return swap.
 * tag: 2617
 * @readonly
 * @enum {number} (int)
 */
export enum UnderlyingNotionalAdjustments {
  Execution = 0,
  PortfolioRebalancing = 1,
  Standard = 2,
}
